var React = require('react');

function Gift (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},[React.createElement("style",{"key":0},".cls-1{fill:url(#linear-gradient);}"),React.createElement("linearGradient",{"id":"linear-gradient","x1":"237.87","y1":"531.75","x2":"647.8","y2":"531.75","gradientUnits":"userSpaceOnUse","key":1},[React.createElement("stop",{"offset":"0","stopColor":"#e17839","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#da4d3a","key":1})])]),React.createElement("polygon",{"className":"cls-1","points":"403.96 210.81 647.8 210.81 445.66 472.31 567.28 448.54 237.87 852.68 386.19 548.09 285.08 570.38 403.96 210.81","key":1})]);
}

Gift.defaultProps = {"id":"Final","viewBox":"0 0 840.99 1021.99"};

module.exports = Gift;

Gift.default = Gift;
